import { Dialog } from "../dialogs/dialog";
import { IncomingSubscribeRequest } from "../messages/methods/subscribe";
import { IncomingRequestDelegate } from "../messages/incoming-request";
import { IncomingRequestMessage } from "../messages/incoming-request-message";
import { NonInviteServerTransaction } from "../transactions/non-invite-server-transaction";
import { UserAgentServer } from "./user-agent-server";

/**
 * Re-SUBSCRIBE UAS.
 * @public
 */
export class ReSubscribeUserAgentServer extends UserAgentServer implements IncomingSubscribeRequest {
  constructor(dialog: Dialog, message: IncomingRequestMessage, delegate?: IncomingRequestDelegate) {
    super(NonInviteServerTransaction, dialog.userAgentCore, message, delegate);
  }
}
